import React, { useState, useEffect } from 'react';
import { MainDiv } from './styles';
import { Modal } from 'antd';
import { SkeletonCard } from '../../pages/life-insurance/skeleton-card/SkeletonCard';

import formatSumAssured from '../../utilities/calculateSum';
import { useNavigate } from 'react-router-dom';

const HealthPlan = ({key, item, viewMoreDetails, setViewMoreDetails }) => {
  const navigate = useNavigate();
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [enquiryId, setEnquiryId] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

      useEffect(() => {
        // Extract enquiryId from the query string
        const queryParams = new URLSearchParams(window.location.search);
        const id = queryParams.get('enquiryId');
        setEnquiryId(id);
      }, []);

  const [show, setShow] = useState(false);
  const handleModal = () => {
    setShow(!show);
  };

  // Handle the toggle of viewMoreDetails
  const handleDetails = () => {
    setViewMoreDetails(!viewMoreDetails);
  };

  const handlePremiumWithSubmitBtn = () => {
    // first check auth token login or not
    const token = localStorage.getItem('Authorization');
    if (!token) {
      alert('Please login then start the process ');
      return;
    }
    navigate(`/ckyc?enquiryId=${enquiryId}`);
  };

  return (
    <div>
      <MainDiv>
        <div className="logo-container" style={{ width: '240px' }}>
          <div className="head">
            <img className="head-img" src={item?.sluginfo?.logo} alt="logo" />
            <p className="sec" style={{ marginLeft: '1rem' }}>
              {item?.sluginfo?.name.split(' ').map((word, index, arr) => {
                const isLife = word.toLowerCase() === 'life';
                return (
                  <React.Fragment key={index}>
                    {isLife ? (
                      <span style={{ color: '#ff3300', fontWeight: 'bold' }}>
                        {word}
                      </span>
                    ) : (
                      word
                    )}
                    {index !== arr.length - 1 ? ' ' : null}
                  </React.Fragment>
                );
              })}
            </p>
          </div>
        </div>
        <hr />
        <div style={{ width: '160px' }}>
          <p>₹{formatSumAssured(item?.sumAssured)}</p>
        </div>
        <hr />
        <div>
          <p>{item?.tenure} Years</p>
        </div>
        <hr />
        {/* <div>
          <p>{item.roomRentLimit}</p>
        </div> */}
        <div>
          <p>{item?.preExistingDisease || 'Not available'}</p>
        </div>
        <hr />
        <div
          style={{ width: '150px', marginLeft: '2rem' }}
          className="btn-container no-flex"
        >
          <button
            onClick={() => {
              handlePremiumWithSubmitBtn();
            }}
            className="price-btn"
          >
            ₹
            {parseInt(item?.priceDetails?.PremiumWithoutTax).toLocaleString(
              'en-IN',
              {
                maximumFractionDigits: 2,
              }
            )}{' '}
            + Tax ₹
            {parseInt(item?.priceDetails?.ServiceTax).toLocaleString('en-IN', {
              maximumFractionDigits: 2,
            })}{' '}
          </button>
        </div>
        <hr />
        <div
          style={{
            marginTop: '1rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem',
            alignItems: 'center',
          }}
        >
          <button className="action-btn">Plan Benefits</button>
          <button className="action-btn"> Hospital List</button>
          <button className="action-btn">
            <a
              href="https://simple-insurance.s3.ap-south-1.amazonaws.com/staging-assets/2025/5/d4cb7439ccb93bb5389db0e98f1ad2a5.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Policy brochure
            </a>
          </button>
        </div>
      </MainDiv>
      <div>
        <div className="detailModal">
          <div className="detailModal__header">
            <div>
              {/* FOR RIDERS */}
              {/* <p>
                ✓ Waiver of Premium Cover{' '}
                <span style={{ color: '#41025F', fontWeight: 'bolder' }}>
                  free
                </span>
              </p> */}

              {/* Static Extra Payout for Accidental Death Benefit */}
              <div style={{ marginTop: '10px' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  {/* FOR RIDERS */}
                </div>
              </div>
            </div>
          </div>

          <div className="specialPlan"></div>
        </div>
      </div>
    </div>
  );
};

export default HealthPlan;
